export { default as MigaDesecho } from "./MigaDesecho";
